<template>
  <div class="md-layout md-alignment-center login">
    <form novalidate @submit.prevent="login">
      <md-card class="md-layout-item md-elevation-3">
        <md-card-header>
          <div class="md-title">Sign in</div>
        </md-card-header>
        <md-card-content>
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-small-size-100">
              <md-field>
                <label>Email</label>
                <md-input required v-model="email" placeholder="email"/>
              </md-field>
            </div>
          </div>
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-small-size-100">
              <md-field>
                <label>Password</label>
                <md-input required v-model="password" type="password" placeholder="Password" />
              </md-field>
            </div>
          </div>
          <div v-if="error">
            <span class="md-error">Error logging in: {{error}}</span>
          </div>
        </md-card-content>
        <md-card-actions>
          <md-button to="home" class="md-accent md-raised">Cancel</md-button>
          <md-button type="submit" class="md-primary md-raised">Login</md-button>
        </md-card-actions>
      </md-card>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: '',
      password: '',
      error: '',
    };
  },

  methods: {
    login() {
      const { email } = this;
      const { password } = this;
      this.$store
        .dispatch('login', { email, password })
        .then(() => {
          this.error = '';
          const { nextPage } = this.$store.getters;
          if (nextPage) {
            this.$store.commit('setNextPage', '');
            this.$router.push(nextPage);
          } else {
            this.$router.push('/');
          }
        })
        .catch((err) => {
          this.error = err.response.data.message;
        });
    },
  },
};
</script>

<style lang="scss">
  .login {
    padding-top: 1rem;
    form {
      min-width: 25rem;
    }
  }
</style>
